export const sortings = [
  {
    value: '',
    label: 'Default',
    availableFor: ['sparkyard-collections'],
  },
  {
    value: 'date-created',
    label: 'Date Created',
    availableFor: ['my-collections', 'sparkyard-collections', 'shared-with-me'],
  },
  {
    value: 'a-to-z',
    label: 'A to Z',
    availableFor: ['my-collections', 'sparkyard-collections', 'shared-with-me'],
  },
  {
    value: 'manual',
    label: 'Manual',
    availableFor: ['my-collections', 'shared-with-me'],
  },
];
